import { render, staticRenderFns } from "./PredialModal.vue?vue&type=template&id=59f264fd"
import script from "./PredialModal.vue?vue&type=script&lang=js"
export * from "./PredialModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports